import store from '@/store/index.js'
import VueRouter from "vue-router"

import Login from '../views/Login/Login.vue'
import Import from '../views/Import.vue'
// import Registration from '../views/Registration.vue'
import AgentRegister from '../views/AgentRegister.vue'
import PasswordReset from '../views/PasswordReset.vue'
import DashboardAgent from '@components/dashboards/DashboardAgent'
import DashboardLawyer from '@components/dashboards/DashboardLawyer'
import DashboardHr from '@components/dashboards/DashboardHr'
import Dashboard from '../views/Dashboard.vue'
import User from '../views/User.vue'
import UserOperations from '../views/UserOperations.vue'
import Department from '../views/Department.vue'
import CompanyDadataCheck from '../views/CompanyDadataCheck.vue'
import Companies from '../views/Companies.vue'
import Agents from '../views/Agents.vue'
import AgentSettlements from '../views/AgentSettlements.vue'
import AgentWithdrawalRequests from '../views/AgentWithdrawalRequests.vue'
import AgentCorpMail from '../views/AgentCorpMail.vue'
import News from '../views/News.vue'
import OrderLogistic from '../views/OrderLogistic.vue'
import Order from '../views/Order.vue'
import OrderPage from '../views/OrderPage.vue'
import OrderServicePage from '../views/OrderServicePage.vue'
import Profile from '../views/Profile.vue'
import ProfileAgent from '../views/ProfileAgent.vue'
import Finance from '../views/Finance.vue'
import FinancePage from '../views/FinancePage.vue'
import FinanceRequests from '../views/FinanceRequests.vue'
import FinancePayments from '../views/FinancePayments.vue'
import FinanceVatZeroExport from '../views/FinanceVatZeroExport.vue'
import Reports from '../views/Reports.vue'
import BDR from '../views/BDR.vue'
import BDRDictionary from '../views/BDRDictionary.vue'
import BDROneCdictionary from '../views/BDROneCdictionary.vue'
import BDR2026 from '../views/BDR2026.vue'
import BDR2026Dictionary from '../views/BDR2026Dictionary.vue'
import BDR2026OneCdictionary from '../views/BDR2026OneCdictionary.vue'
import Tasks from '../views/Tasks.vue'
import Motivation from '../views/Motivation.vue'
import Motivation2025 from '../views/motivation2025/Motivation2025.vue'
import MotivationScoring from '../views/MotivationScoring.vue'
import MotivationReport from '../views/MotivationReport.vue'
import Driver from '../views/Driver'
import Truck from '../views/Truck'
import ExportPartnerInformation from '../views/ExportPartnerInformation'
import Tickets from '../views/Tickets/Tickets'
import ClientPortfolio from '../views/ClientPortfolio'
import ClientScores from '../views/ClientScores'
import OrderKanban from '../views/OrderKanban/OrderKanban'
import OrderKanbanTable from '../views/OrderKanban/OrderKanbanTable'
import References from '@/views/References'
import CalendarPage from '@/views/CalendarPage'
import Help from '@/views/Help'
import CompetitorPage from '@/views/CompetitorPage'
import OrderServiceReport from '@/views/OrderServiceReport'
import OrderTOActivityReport from '@/views/OrderTOActivityReport'
import QuotationRatesReport from '@/views/QuotationRatesReport'
import DepartmentEfficiencyReport from '@/views/DepartmentEfficiencyReport'
import OrderFinanceReport from '@/views/OrderFinanceReport'
import OrderSupplierRequestsReport from '@/views/OrderSupplierRequestsReport'
import SalesAnalytic from '@/views/SalesAnalytic'
import OrderAnalytic from '@/views/OrderAnalytic'
import FinanceAnalytic from '@/views/FinanceAnalytic'
import UsefulMaterials from '@/views/UsefulMaterials'
import MakeYourTeam from '@/views/MakeYourTeam'
import ColdClients from '@/views/ColdClients'
import AgentsOfertaPage from '@/views/AgentsOfertaPage'
import PrivacyPolicyPage from '@/views/PrivacyPolicyPage'
import Calculator from '@/views/Calculator'

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters['auth/isAuthenticated']) {
        return next()
    }
    const userRoles = store.getters['auth/getUserRoles'] || []
    next(userRoles.includes('lead-observer') ? '/orders' : '/dashboard')
}

// const ifAuthenticated = (to, from, next) => {
//     if (store.getters['auth/isAuthenticated']) {
//         if (store.getters['auth/getUserRoles'].includes('client')) {
//             if (to.path !== '/orders' && to.path !== '/finance' && to.path !== '/profile') {
//                 return next('/orders')
//             } else {
//                 return next()
//             }
//         } else {
//             return next()
//         }
//     } else {
//         store.commit('auth/SET_TEMP_LINK', to.fullPath)
//         return next('/login')
//     }
// }
const ifAuthenticated = (to, from, next) => {
    if (!store.getters['auth/isAuthenticated']) {
        store.commit('auth/SET_TEMP_LINK', to.fullPath)
        return next('/login')
    }

    let userRoles = store.getters['auth/getUserRoles']
    if (!Array.isArray(userRoles)) {
        userRoles = [userRoles].filter(Boolean)
    }

    // Проверка на расторжение договора для агентов
    if (userRoles.includes('agent')) {
        const agentCompany = store.getters['auth/getAgentCompany']
        if (agentCompany && (
            agentCompany.check_status === 'termination_by_agent' ||
            agentCompany.check_status === 'termination_by_company' ||
            agentCompany.check_status === 'rejected'
        )) {
            // Разрешаем доступ только к дашборду и профилю
            if (to.path === '/dashboard' || to.path === '/profile') {
                return next()
            } else {
                // Перенаправляем на дашборд с сообщением о блокировке
                store.commit('auth/SET_TEMP_LINK', to.fullPath)
                return next('/dashboard')
            }
        }
    }

    // Наблюдатель лидов: только Заказы и Профиль, дашборда нет — по умолчанию открываются заказы
    if (userRoles.includes('lead-observer')) {
        if (to.path === '/' || to.path === '/dashboard') {
            return next('/orders')
        }
        if (to.name === 'orderservicepage' || to.name === 'orderByserviceLogistic' || to.name === 'orderByservice') {
            return next('/orders')
        }
        const allowedPaths = ['/orders', '/profile']
        if (!allowedPaths.includes(to.path)) {
            return next('/orders')
        }
    }

    const allowedRoles = to.meta.allowedRoles || null
    const deniedRoles = to.meta.notAllowedRoles || null

    if (allowedRoles && allowedRoles.length > 0) {
        const isAllowed = userRoles.some(role => allowedRoles.includes(role))
        if (!isAllowed) {
            return next('/login')
        } else {
            return next() // только если явно разрешено
        }
    }

    if (deniedRoles && deniedRoles.length > 0) {
        const isDenied = userRoles.some(role => deniedRoles.includes(role))
        if (isDenied) {
            return next('/login')
        }
    }

    return next()
}

let routes = [
        {
            path: '/',
            redirect: { name: 'dashboard' }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: { title: 'Авторизация | TANASOFT', middlewareAuth: true },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/password/reset',
            name: 'passwordReset',
            component: PasswordReset,
            meta: { title: 'Восстановление пароля | TANASOFT', middlewareAuth: true },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/reset',
            redirect: to => {
                // Перенаправляем на /password/reset с сохранением query параметров
                return { path: '/password/reset', query: to.query }
            }
        },
        {
            path: '/import',
            name: 'Import',
            component: Import,
            meta: { title: 'Импорт | TANASOFT', middlewareAuth: true, allowedRoles: ['administrator', 'president'] },
            beforeEnter: ifAuthenticated
        },
        // {
        //     path: '/register',
        //     name: 'register',
        //     component: Registration
        // },
        {
            path: '/agent-register',
            name: 'agentRegister',
            component: AgentRegister,
            meta: { title: 'Регистрация нового агента | TANASOFT', middlewareAuth: true },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/agents-oferta',
            name: 'agentsOferta',
            component: AgentsOfertaPage,
            meta: { title: 'Оферта для агентов | TANASOFT', middlewareAuth: true },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/privacy-policy',
            name: 'privacyPolicy',
            component: PrivacyPolicyPage,
            meta: { title: 'Политика конфиденциальности | TANASOFT', middlewareAuth: true },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/logout',
            name: 'logout',
            meta: { logout: true }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: { title: 'Панель информации', middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/users/operations',
            name: 'usersOperations',
            component: UserOperations,
            meta: { title: 'Операции с пользователями', middlewareAuth: true, allowedRoles: ['administrator', 'president'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/users',
            name: 'users',
            component: User,
            meta: { title: 'Пользователи', middlewareAuth: true, allowedRoles: ['administrator', 'president', 'TO-head-manager'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/departments',
            name: 'departments',
            component: Department,
            meta: { title: 'Отделы', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta: { title: 'Профиль', middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/calculator',
            name: 'calculator',
            component: Calculator,
            meta: { title: 'Калькулятор', middlewareAuth: true, notAllowedRoles: ['client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/companies/dadata-check',
            name: 'CompanyDadataCheck',
            component: CompanyDadataCheck,
            meta: { title: 'Автоматическая проверка данных компаний', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/companies',
            name: 'companies',
            component: Companies,
            meta: { title: 'Компании', middlewareAuth: true, notAllowedRoles: ['client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/agents',
            name: 'agents',
            component: Agents,
            meta: { title: 'Агенты', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/agent-corp-mail',
            name: 'agentCorpMail',
            component: AgentCorpMail,
            meta: { title: 'Корпоративная почта агентов', middlewareAuth: true, allowedRoles: ['administrator', 'president'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/make-your-team',
            name: 'makeYourTeam',
            component: MakeYourTeam,
            meta: { title: 'Создай свою команду', middlewareAuth: true, allowedRoles: ['agent'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/agent-settlements',
            name: 'agentSettlements',
            component: AgentSettlements,
            meta: { title: 'Взаиморасчеты с агентами', middlewareAuth: true, notAllowedRoles: ['client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/agent-withdrawal-requests',
            name: 'AgentWithdrawalRequests',
            component: AgentWithdrawalRequests,
            meta: { title: 'Заявки на вывод средств', middlewareAuth: true, allowedRoles: ['administrator', 'president', 'accountant', 'head-accountant', 'agent'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/cold-clients',
            name: 'coldClients',
            component: ColdClients,
            meta: { title: 'Клиентская база', middlewareAuth: true, allowedRoles: ['agent', 'administrator', 'president', 'TO-head-manager', 'TO-manager'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/news',
            name: 'news',
            component: News,
            meta: { title: 'Новости', middlewareAuth: true, allowedRoles: ['administrator', 'president'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/orders',
            name: 'orders',
            component: Order,
            meta: { title: 'Заказы', middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/reports',
            name: 'reports',
            component: Reports,
            meta: { title: 'Аналитика', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/orders/:order_id',
            name: 'orderPage',
            redirect: to => {
                return { path: '/orders', query: { order: to.params.order_id } }
            },
            component: OrderPage,
            meta: { middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/orders/:order_id/services/:service_id',
            name: 'orderservicepage',
            component: OrderServicePage,
            meta: { middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/orders/services/logistics',
            name: 'orderByserviceLogistic',
            component: OrderLogistic,
            meta: { services: { 22: 'Таможенное оформление', 23: 'Логистика', 24: 'Сертификация', 25: 'Консалтинг и сопутствующие услуги', 75: 'ПНК', 76: 'СВХ', 77: 'Страхование' }, middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/orders/services/:service_id',
            name: 'orderByservice',
            component: Order,
            meta: { services: { 22: 'Таможенное оформление', 23: 'Логистика', 24: 'Сертификация', 25: 'Консалтинг и сопутствующие услуги', 75: 'ПНК', 76: 'СВХ', 77: 'Страхование' }, middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/finance',
            name: 'finance',
            component: Finance,
            meta: { title: 'Финансы', middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/finance/payments',
            name: 'financePayments',
            component: FinancePayments,
            meta: { title: 'Платежи', middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/finance/requests',
            name: 'financeRequests',
            component: FinanceRequests,
            meta: { title: 'Запросы', middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/finance/vat-zero-export',
            name: 'financeVatZeroExport',
            component: FinanceVatZeroExport,
            meta: {
                title: 'Выгрузка НДС 0',
                middlewareAuth: true,
                allowedRoles: [
                    'administrator',
                    'president',
                    'accountant',
                    'head-accountant',
                    'logistics-manager',
                    'logistics-head-manager',
                    'logistics-multim-manager',
                    'logistics-multim-head-manager',
                ],
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/finance/requests/:user_id',
            name: 'FinanceRequestsByUser',
            component: FinanceRequests,
            meta: { middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/finance/:finance_id',
            name: 'FinancePage',
            redirect: to => {
              return { path: '/finance', query: { finance: to.params.finance_id } }
            },
            component: FinancePage,
            meta: { middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/finance/by-invoice-type/:invoice_type',
            name: 'financeFilteredByInvoiceType',
            component: Finance,
            meta: { invoices_type: { incoming: 'Покупатель', outgoing: 'Поставщик' }, middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/budget/onec-dictionary',
            name: 'budgetOneCDictionary',
            component: BDROneCdictionary,
            meta: { title: 'Словари для бюджета доходов и расходов 1C', middlewareAuth: true, allowedRoles: ['administrator', 'president', 'accountant', 'head-accountant'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/budget/dictionary',
            name: 'budgetDictionary',
            component: BDRDictionary,
            meta: { title: 'Словари для бюджета доходов и расходов', middlewareAuth: true, allowedRoles: ['administrator', 'president', 'accountant', 'head-accountant'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/budget',
            name: 'budget',
            component: BDR,
            meta: { title: 'Бюджет доходов и расходов', middlewareAuth: true, allowedRoles: ['administrator', 'president', 'accountant', 'head-accountant'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/budget-2026/dictionary',
            name: 'budget2026Dictionary',
            component: BDR2026Dictionary,
            meta: { title: 'Словарь Бюджет', middlewareAuth: true, allowedRoles: ['administrator', 'president', 'accountant', 'head-accountant'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/budget-2026/onec-dictionary',
            name: 'budget2026OneCDictionary',
            component: BDR2026OneCdictionary,
            meta: { title: 'Словарь 1С (Бюджет)', middlewareAuth: true, allowedRoles: ['administrator', 'president', 'accountant', 'head-accountant'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/budget-2026',
            name: 'budget2026',
            component: BDR2026,
            meta: { title: 'Бюджет', middlewareAuth: true, allowedRoles: ['administrator', 'president', 'accountant', 'head-accountant'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/tasks',
            name: 'tasks',
            component: Tasks,
            meta: { title: 'Задачи', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/motivation-2025',
            name: 'motivation-2025',
            component: Motivation,
            meta: { title: 'Расчет мотивации (2025)', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/motivation',
            name: 'motivation',
            component: Motivation2025,
            meta: { title: 'Мотивация сотрудников', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/motivation/report',
            name: 'MotivationReport',
            component: MotivationReport,
            meta: { title: 'Итоги мотивации', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/motivation/scoring/:report_date',
            name: 'motivationScoring',
            component: MotivationScoring,
            meta: { title: 'Оценка мотивации сотрудников', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/drivers',
            name: 'drivers',
            component: Driver,
            meta: { title: 'Водители', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/trucks',
            name: 'trucks',
            component: Truck,
            meta: { title: 'Транспортные средства', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/export/partner-information',
            name: 'exportPartnerInformation',
            component: ExportPartnerInformation,
            meta: { title: 'Экспорт данных заказов по Партнерам', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/useful-materials',
            name: 'usefulMaterials',
            component: UsefulMaterials,
            meta: { title: 'Полезные материалы', middlewareAuth: true, notAllowedRoles: ['client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/tickets',
            name: 'tickets',
            component: Tickets,
            meta: { title: 'Техническая поддержка', middlewareAuth: true },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/reports/order-finance',
            name: 'OrderFinanceReport',
            component: OrderFinanceReport,
            meta: {
                title: 'Финансовые показатели заказов',
                middlewareAuth: true,
                allowedRoles: ['administrator', 'president', 'head-accountant', 'sales-head-manager', 'TO-head-manager', 'logistics-head-manager', 'logistics-multim-head-manager']
            },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/reports/sales-analytic',
            name: 'salesAnalytic',
            component: SalesAnalytic,
            meta: { title: 'Отдел продаж', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/reports/order-service-activity',
            name: 'OrderServiceReport',
            component: OrderServiceReport,
            meta: { title: 'Активность по поставкам', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/reports/order-to-activity',
            name: 'OrderTOActivityReport',
            component: OrderTOActivityReport,
            meta: { title: 'Активность по ТО', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/reports/quotation-rates',
            name: 'QuotationRatesReport',
            component: QuotationRatesReport,
            meta: { title: 'Ставки по заявкам', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/reports/department-efficiency',
            name: 'DepartmentEfficiencyReport',
            component: DepartmentEfficiencyReport,
            meta: { title: 'Эффективность отделов', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/reports/competitors',
            name: 'competitorsAnalytic',
            component: CompetitorPage,
            meta: { title: 'Анализ рынка', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/reports/order-analytic',
            name: 'orderAnalytic',
            component: OrderAnalytic,
            meta: { title: 'Аналитика поставок', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/reports/finance-analytic',
            name: 'financeAnalytic',
            component: FinanceAnalytic,
            meta: { title: 'Аналитика финансов', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/reports/client-portfolio',
            name: 'clientPortfolio',
            component: ClientPortfolio,
            meta: { title: 'Клиентский портфель', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/reports/order-scores',
            name: 'clientScores',
            component: ClientScores,
            meta: { title: 'Клиентские оценки поставок', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/reports/order-delivery-quotation',
            name: 'OrderSupplierRequestsReport',
            component: OrderSupplierRequestsReport,
            meta: { title: 'Аналитика запросов на котировку поставщикам услуг', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/order-kanban',
            component: OrderKanban,
            meta: { title: 'Заявки', middlewareAuth: true, notAllowedRoles: ['client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/order-kanban/table/:id',
            component: OrderKanbanTable,
            meta: { title: 'Таблица заявок', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/references',
            name: 'references',
            component: References,
            meta: { title: 'Справочники', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: CalendarPage,
            meta: { title: 'Календарь', middlewareAuth: true, notAllowedRoles: ['agent', 'client'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/help',
            name: 'help',
            component: Help,
            meta: { title: 'Помощь в работе с системой', middlewareAuth: true },
            beforeEnter: ifAuthenticated,
        }
    ]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    if (to.name === 'dashboard' && store.getters['auth/isAuthenticated']) {
        const userRoles = store.getters['auth/getUserRoles'];
    
        // Подмены для агентов
        if (userRoles.includes('agent')) {
          to.matched[0].components.default = DashboardAgent;
        }
        
        // Подмены для lawyer ролей
        if (userRoles.includes('lawyer-manager') || userRoles.includes('lawyer-head-manager')) {
          to.matched[0].components.default = DashboardLawyer;
        }
        
        // Подмены для hr ролей
        if (userRoles.includes('hr-manager') || userRoles.includes('hr-head-manager')) {
          to.matched[0].components.default = DashboardHr;
        }
    }

    if (to.name === 'profile' && store.getters['auth/isAuthenticated']) {
        const userRoles = store.getters['auth/getUserRoles'];
    
        // Подмены для агентов
        if (userRoles.includes('agent')) {
          to.matched[0].components.default = ProfileAgent;
        }
    }

    // Показываем уведомление о блокировке роутов для агентов с расторгнутым договором
    if (store.getters['auth/isAuthenticated']) {
        const userRoles = store.getters['auth/getUserRoles'];
        if (userRoles.includes('agent')) {
            const agentCompany = store.getters['auth/getAgentCompany'];
            if (agentCompany && (
                agentCompany.check_status === 'termination_by_agent' || 
                agentCompany.check_status === 'termination_by_company' ||
                agentCompany.check_status === 'rejected'
            )) {
                // Сохраняем информацию о попытке доступа к заблокированному роуту
                if (to.path !== '/dashboard' && to.path !== '/profile') {
                    sessionStorage.setItem('blockedRoute', to.path);
                    sessionStorage.setItem('showBlockedRouteMessage', 'true');
                }
            }
        }
    }
    
    next();
});

export default router
